import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, H4, Image, LI, P, UL } from "../../../AbstractElements";
import { StaticBackdropModal, StaticModalTitle } from "../../../Constants/Constants";
import { StaticModalSubTitle } from "../../../Data/UiKits/Modal";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonModal from "./Common/CommonModal";

const StaticModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const ModalData = {isOpen: modal,toggler: toggle,bodyClass: "dark-sign-up social-profile text-start"};

  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={StaticModalTitle} span={StaticModalSubTitle} />
        <CardBody>
          <Btn color="primary" onClick={toggle}>
            {StaticBackdropModal}
          </Btn>
          <CommonModal modalData={ModalData}>
            <div className="modal-toggle-wrapper">
              <UL className="modal-img simple-list">
                <LI className="text-center">
                  <Image src={dynamicImage("gif/time.gif")} alt="alarm" />
                </LI>
              </UL>
              <H4 className="text-center pb-2">Failed to establish a connection.</H4>
              <P className="text-center">Getting back in touch in <b className="txt-warning">14 seconds...</b></P>
              <Btn color="warning" className="d-flex m-auto" onClick={toggle}>Close</Btn>
            </div>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  );
};
export default StaticModal;
